import { Icon } from "@chakra-ui/react";

const BathIcon = (props: any) => (
  <Icon viewBox="0 0 25 24" fill="none" {...props}>
    <path
      d="M3.5 13.0827C3.5 13.0059 3.5 12.9675 3.50211 12.9351C3.5347 12.4339 3.93395 12.0347 4.43511 12.0021C4.46752 12 4.50591 12 4.58268 12H20.4173C20.4941 12 20.5325 12 20.5649 12.0021C21.0661 12.0347 21.4653 12.4339 21.4979 12.9351C21.5 12.9675 21.5 13.0059 21.5 13.0827C21.5 13.4784 21.5 13.6762 21.4859 13.8977C21.2773 17.1854 18.483 20.0867 15.2053 20.4186C14.9845 20.441 14.8558 20.4458 14.5982 20.4555C13.864 20.4831 13.1493 20.5 12.5 20.5C11.8507 20.5 11.136 20.4831 10.4018 20.4555C10.1442 20.4458 10.0155 20.441 9.79467 20.4186C6.51705 20.0867 3.72272 17.1854 3.51406 13.8977C3.5 13.6762 3.5 13.4784 3.5 13.0827Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M6.5 20L5.5 22"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M18.5 20L19.5 22"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M2.5 12H22.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M2.75 13C2.75 13.4142 3.08579 13.75 3.5 13.75C3.91421 13.75 4.25 13.4142 4.25 13H2.75ZM8.09973 3.49934L8.79609 3.22079L8.79609 3.22079L8.09973 3.49934ZM8.47885 4.44713L8.80713 5.12147L8.47885 4.44713ZM6.86212 6.19232L7.55701 6.47451L6.86212 6.19232ZM11.077 4.37783L10.7824 5.06753L11.077 4.37783ZM6.84559 8.74156L6.1478 9.01651C6.22221 9.20535 6.36997 9.35596 6.55735 9.43396C6.74473 9.51197 6.95572 9.51069 7.14215 9.43044L6.84559 8.74156ZM12.8063 6.17548L13.1029 6.86436C13.475 6.70417 13.6526 6.27744 13.5041 5.90053L12.8063 6.17548ZM4.25 13V4.38516H2.75V13H4.25ZM5.88516 2.75C6.55379 2.75 7.15506 3.15708 7.40338 3.77788L8.79609 3.22079C8.31998 2.0305 7.16715 1.25 5.88516 1.25V2.75ZM4.25 4.38516C4.25 3.48209 4.98209 2.75 5.88516 2.75V1.25C4.15366 1.25 2.75 2.65366 2.75 4.38516H4.25ZM7.40338 3.77788L7.7825 4.72568L9.17521 4.16859L8.79609 3.22079L7.40338 3.77788ZM7.54337 8.46661C7.30167 7.85321 7.28638 7.14092 7.55701 6.47451L6.16723 5.91014C5.74692 6.94515 5.76959 8.05665 6.1478 9.01651L7.54337 8.46661ZM12.5098 5.4866L6.54903 8.05268L7.14215 9.43044L13.1029 6.86436L12.5098 5.4866ZM10.7824 5.06753C11.4039 5.33307 11.867 5.83741 12.1086 6.45043L13.5041 5.90053C13.1258 4.94029 12.387 4.12189 11.3717 3.68813L10.7824 5.06753ZM7.55701 6.47451C7.81118 5.8486 8.26827 5.3838 8.80713 5.12147L8.15058 3.77279C7.28337 4.19496 6.56253 4.93671 6.16723 5.91014L7.55701 6.47451ZM8.80713 5.12147C9.41452 4.82579 10.1251 4.78672 10.7824 5.06753L11.3717 3.68813C10.2939 3.22768 9.12874 3.29661 8.15058 3.77279L8.80713 5.12147Z"
      fill="currentColor"
    />
  </Icon>
);

export default BathIcon;
